import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Show } from "@clerk/react";
import { Toaster } from "@/components/ui/sonner";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import { MeProvider, useMe } from "@/context/MeContext";
import AuthPage from "@/pages/AuthPage";
import PendingPage from "@/pages/PendingPage";
import ShowsPage from "@/pages/ShowsPage";
import ShowPage from "@/pages/ShowPage";
import VehiclePage from "@/pages/VehiclePage";
import UsersPage from "@/pages/UsersPage";

const CrewRoutes = () => {
  const me = useMe();
  if (me.role === "pending") return <PendingPage />;
  return (
    <Routes>
      <Route path="/" element={<ShowsPage />} />
      <Route path="/show/:sid" element={<ShowPage />} />
      <Route path="/show/:sid/v/:vk" element={<VehiclePage />} />
      <Route path="/usuarios" element={<UsersPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

const Protected = () => (
  <>
    <Show when="signed-in"><MeProvider><CrewRoutes /></MeProvider></Show>
    <Show when="signed-out"><Navigate to="/sign-in" replace /></Show>
  </>
);

function App() {
  return (
    <div className="App dark">
      <BrowserRouter>
        <ClerkAuthProvider>
          <Routes>
            <Route path="/sign-in/*" element={<AuthPage mode="sign-in" />} />
            <Route path="/sign-up/*" element={<AuthPage mode="sign-up" />} />
            <Route path="/*" element={<Protected />} />
          </Routes>
        </ClerkAuthProvider>
      </BrowserRouter>
      <Toaster theme="dark" position="top-center" richColors />
    </div>
  );
}

export default App;
